/* BonheurReBorn — Theme JS */

/* Product card swipe (debounced MutationObserver) */
(function() {
  /* Kart slaytı 2-5 (16 Eki 2026): sunucu src/srcset vermez (data-card-src) → kaydırma NİYETİ gelene dek
     indirilmez. Niyet = yatay parmak hareketi (dikey sayfa kaydırması kartlara dokunsa da TETİKLEMEZ) ya da
     şeridin kendisinin kayması. srcset, kartın data-widths listesinden kurulur (≤ data-max = orijinal genişlik). */
  function hydrateCard(card) {
    if (card.__cardHydrated) return;
    card.__cardHydrated = true;
    var widths = (card.getAttribute('data-widths') || '200,300,400,500,600').split(',');
    card.querySelectorAll('img[data-card-src]').forEach(function(img) {
      var base = img.getAttribute('data-card-src');
      var max = parseInt(img.getAttribute('data-max'), 10) || 0;
      var set = [];
      widths.forEach(function(w) {
        w = parseInt(w, 10);
        if (w && (!max || w <= max)) set.push(base.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w');
      });
      img.setAttribute('loading', 'eager'); /* niyet görüldü → yatay taşmadaki slaytı beklemeden indir */
      if (set.length) img.setAttribute('srcset', set.join(', '));
      img.setAttribute('src', base);
      img.removeAttribute('data-card-src');
    });
  }
  function bindHydrate(card, track) {
    if (!card.querySelector('img[data-card-src]')) return;
    var x0 = 0, y0 = 0;
    track.addEventListener('touchstart', function(e) {
      var t = e.touches && e.touches[0]; if (t) { x0 = t.clientX; y0 = t.clientY; }
    }, { passive: true });
    track.addEventListener('touchmove', function(e) {
      if (card.__cardHydrated) return;
      var t = e.touches && e.touches[0]; if (!t) return;
      var dx = Math.abs(t.clientX - x0), dy = Math.abs(t.clientY - y0);
      if (dx > 6 && dx > dy) hydrateCard(card);
    }, { passive: true });
  }
  function initSwipe() {
    document.querySelectorAll('[data-swipe]:not([data-swipe-init])').forEach(function(card) {
      card.setAttribute('data-swipe-init', '');
      var track = card.querySelector('.product-card__swipe-track');
      var dots = card.querySelectorAll('.product-card__dot');
      if (track) bindHydrate(card, track);
      if (!track || !dots.length) return;
      track.addEventListener('scroll', function() {
        hydrateCard(card);
        var w = track.offsetWidth;
        if (!w) return;
        var i = Math.round(track.scrollLeft / w);
        dots.forEach(function(d, j) { d.classList.toggle('active', j === i); });
      }, { passive: true });
    });
  }
  document.addEventListener('DOMContentLoaded', initSwipe);
  var debounceTimer;
  /* Observe only #main, not <body>. Web-pixels/Klaviyo/analytics inject nodes into <body>
     and <head> constantly; watching the whole body subtree re-fired this observer on every
     such mutation. Dynamically-added product cards live inside #main, so scoping there keeps
     swipe-init working while cutting the constant microtask churn on the webview. */
  document.addEventListener('DOMContentLoaded', function() {
    var root = document.getElementById('main') || document.body;
    new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(initSwipe, 100);
    }).observe(root, { childList: true, subtree: true });
  });
})();

/* Mobile menu toggle */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var menu = document.querySelector('[data-mobile-menu]');
    var overlay = document.querySelector('[data-menu-overlay]');
    var toggles = document.querySelectorAll('[data-menu-toggle]');
    if (!menu || !toggles.length) return;

    /* Body scroll-lock KULLANMA (kırmızı kural): position:fixed kilidi +
       html{scroll-behavior:smooth} birleşince kapanışta sayfa tepeye zıplayıp
       aşağı kayıyordu. Hapis CSS'le: .mobile-menu__inner overscroll-behavior:contain,
       overlay touch-action:none (base.css). Arkaplanın hafif kayması kabul edilir. */
    function open() {
      menu.classList.add('is-open'); if (overlay) overlay.classList.add('is-visible');
    }
    function close() {
      menu.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-visible');
    }

    toggles.forEach(function(btn) { btn.addEventListener('click', function() { menu.classList.contains('is-open') ? close() : open(); }); });
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
  });
})();

/* Sticky header scroll state (shadow + glass) — single rAF-throttled listener.
   Was two separate scroll listeners; the second wrote to the DOM every frame (no guard)
   which janked the fixed/blurred header in webviews. Merged + guarded here. */
(function() {
  var header = document.querySelector('.header') || document.querySelector('[data-header]');
  if (!header) return;
  var on = false, ticking = false;
  function update() {
    ticking = false;
    var s = (window.scrollY || window.pageYOffset || 0) > 5;
    if (s !== on) {
      on = s;
      header.classList.toggle('header--scrolled', s);
      header.classList.toggle('is-scrolled', s);
    }
  }
  window.addEventListener('scroll', function() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();

/* Cart item remove (delegated) */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-remove-key]');
    if (!btn) return;
    e.preventDefault();
    btn.style.opacity = '0.3';
    btn.style.pointerEvents = 'none';
    var row = btn.closest('.cart-item');
    if (row) row.style.opacity = '0.4';

    var cartItem = btn.closest('.cart-item');
    var updates = {};

    var allKeys = cartItem ? cartItem.getAttribute('data-all-keys') : null;
    if (allKeys) {
      allKeys.split(',').forEach(function(k) { if (k) updates[k] = 0; });
    } else {
      updates[btn.getAttribute('data-remove-key')] = 0;
    }

    var giftKey = cartItem ? cartItem.getAttribute('data-gift-key') : null;
    if (giftKey) updates[giftKey] = 0;

    var variantId = cartItem ? cartItem.getAttribute('data-variant-id') : null;

    var R = (window.routes || {});
    var cartJsUrl = (R.cart_url || '/cart') + '.js';
    var cartUpdateUrl = (R.cart_update_url || '/cart/update') + '.js';

    fetch(cartJsUrl).then(function(r) { return r.json(); }).then(function(cart) {
      cart.items.forEach(function(ci) {
        if (ci.properties && ci.properties._gift === 'true' && ci.properties._parent_variant === variantId) {
          updates[ci.key] = 0;
        }
      });
      return fetch(cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    }).then(function() { window.location.reload(); }).catch(function(err) {
      console.error('[cart-remove]', err);
      btn.style.opacity = ''; btn.style.pointerEvents = '';
      if (row) row.style.opacity = '';
      alert('Bağlantı sorunu, lütfen tekrar deneyin.');
    });
  });
})();

/* Tükenen hediyeyi DEĞİŞTİR (delegated) — cart-item.liquid'in "stokta yok"
   satırındaki buton. Sıra ÖNEMLİ: önce yeni hediye eklenir, sonra ölü satır
   düşer (ters sırada ekleme patlarsa müşteri hediyesiz kalırdı). Değiştirme
   işini picker yürütür; picker yoksa (havuzda satılabilir model kalmamış)
   ölü satır düşürülüp sayfa tazelenir — sepet yalan söylemeyi bırakır. */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-gift-swap-key]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('data-busy') === '1') return;

    var key = btn.getAttribute('data-gift-swap-key');
    var parent = btn.getAttribute('data-gift-parent');

    if (parent && typeof window.__giftPickerOpenGiftOnly === 'function') {
      window.__giftPickerOpenGiftOnly(parseInt(parent, 10), key);
      return;
    }

    btn.setAttribute('data-busy', '1');
    btn.style.opacity = '0.5';
    var R = (window.routes || {});
    var cartChangeUrl = (R.cart_change_url || '/cart/change') + '.js';
    fetch(cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function(r) {
      if (!r.ok) { throw new Error('cart/change ' + r.status); }
      window.location.reload();
    }).catch(function(err) {
      console.error('[gift-swap]', err);
      btn.setAttribute('data-busy', '0');
      btn.style.opacity = '';
      alert('Bağlantı sorunu, lütfen tekrar deneyin.');
    });
  });
})();

/* Clear cart */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-clear-cart]');
    if (!btn) return;
    if (btn.getAttribute('data-busy') === '1') return;
    /* İlk dokunuş yalnız sorar: buton ödeme butonunun hemen altında, yanlış bir dokunuş
       çantayı + hediyeyi onaysız siliyordu. 4 sn içinde ikinci dokunuş gelmezse eski hâline döner. */
    var confirmText = btn.getAttribute('data-confirm-text');
    if (confirmText && btn.getAttribute('data-armed') !== '1') {
      var original = btn.textContent;
      btn.setAttribute('data-original-text', original);
      btn.setAttribute('data-armed', '1');
      btn.textContent = confirmText;
      setTimeout(function() {
        if (btn.getAttribute('data-busy') === '1') return;
        btn.removeAttribute('data-armed');
        btn.textContent = original;
      }, 4000);
      return;
    }
    btn.setAttribute('data-busy', '1');
    btn.style.opacity = '0.3';
    var R = (window.routes || {});
    var cartClearUrl = (R.cart_url || '/cart') + '/clear.js';
    fetch(cartClearUrl, { method: 'POST' }).then(function(r) {
      if (!r.ok) { throw new Error('cart/clear ' + r.status); }
      window.location.reload();
    }).catch(function(err) {
      console.error('[cart-clear]', err);
      btn.removeAttribute('data-busy');
      btn.removeAttribute('data-armed');
      if (btn.getAttribute('data-original-text')) btn.textContent = btn.getAttribute('data-original-text');
      btn.style.opacity = '';
      alert('Bağlantı sorunu, lütfen tekrar deneyin.');
    });
  });
})();

/* Shared cart data — fetch once, share across scripts */
(function() {
  var _promise = null;
  window.__getCart = function() {
    if (!_promise) {
      var R = (window.routes || {});
      var cartJsUrl = (R.cart_url || '/cart') + '.js';
      _promise = fetch(cartJsUrl).then(function(r) { return r.json(); });
    }
    return _promise;
  };
})();

/* Ürün açıklamasından "Çanta görselindeki kayış siparişinize dahil değildir." cümlesini kaldır */
(function() {
  document.querySelectorAll('.product-page__accordion-body.prose, .product-page__accordion-body').forEach(function(el) {
    el.querySelectorAll('*').forEach(function(node) {
      if (node.children.length === 0 && node.textContent.includes('dahil değildir')) {
        var li = node.closest('li');
        if (li) li.remove();
        else { var p = node.closest('p'); if (p) p.remove(); }
      }
    });
  });
})();

